// extracted by mini-css-extract-plugin
module.exports = {"Table":"Table_Table__ldD01","KendoGrid":"Table_KendoGrid__3jo1g"};